module.exports = __webpack_public_path__ + "img/logo-headline65x400.2d95f5f8.png";